/**
 * apploft-cloud-stage-pubkey.js
 *
 * Copyright (c) apploft. GmbH
 */


/**
 * Public key to encrypt user credentials with. This should be
 * configurable somehow, or baked in during deployment, instead
 * of being hard-coded here.
 */
export const publicKey = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAuamOrD6x3p3TqLzteL2Z
nUIsf0AbfVc9+4d5H9pTFgu9inLhVWpbdabxTfRfAahbupyb7irF5E28ySk4a3ot
6MDUelxOF/6ZwCjiNh9P4P8dN0Iv+Ji1Hc9YU+XoVdRV3ZnZM5s6CNwA2gKVpOJj
bZoJ8UFdp5EHoNcagpF2C7vdkfwO8Cp2VmVPkQbMP3x7o/N46T2czKQlVFqxopR8
1VMHsjgX/8IN0HbfpQSF+wSbvbyPhN3UI3PrjdZN6uLgdbpTrPR8RVHr7y2P/5O3
/QcWHrJSuQiITkmH00P/+WzSpmZ6MFfL463D++YNbYdcjO/yS8Wjr5j0ZzBx+CiL
PoRJknfgUk6FOxuysgjS9VgnMFRIDLnxAMx6CQCeAewugB7fJQ+BxUMizyMNeIdt
9+cA/dTHlSy701FNknFeKeZnHjHgIKPxaGf1flgNJ7TAISP2yRp2DNSjeCFDUw6e
oH5BSZq2Hobbxih6OttMyoewixKh7d1I4BTkCqdTFMRoopYYEwcxIwgTWzQcflUs
obIXh2VXQ8p7zfUgY16kM7grGGPwjrFpg+BQTiZp1h8u9zV4elNq3adQMLXca8S7
L41jE0IL5iEqN8Ped3gOmTOH7nrtOGVwoMlAMSmbFlGcFM6orJzYrZWgxF8Jhlbq
no/C8Lb4SvQMWtaCKM1fyy8CAwEAAQ==
-----END PUBLIC KEY-----`;
